<template>
    <div>
        <div class="rounded-lg h-12 px-5 flex items-center border border-snow-200 cursor-pointer" @click="openModal">
            <template v-if="Object.entries(active_country).length">
                <img :src="require('@/assets/svg/flags/' + active_country.code + '.svg')" alt="" class="mr-2" />
            </template>
            <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.30617 7.87641C6.90704 8.42947 6.08354 8.42946 5.6844 7.8764L1.14412 1.5852C0.66682 0.923839 1.1394 -8.23802e-08 1.95501 -1.10774e-08L11.0356 7.82771e-07C11.8512 8.54074e-07 12.3238 0.923842 11.8465 1.58521L7.30617 7.87641Z"
                    fill="#E0E6ED"
                />
            </svg>
        </div>
        <template>
            <biller-modal
                :isVisible="(showModal && !Object.entries(active_country).length) || openModalClicked"
                @close="closeModal"
            >
                <div class="pt-8 pb-5">
                    <div class="flex justify-between md:items-center pl-6 mb-6 flex-col md:flex-row pr-6">
                        <p class="text-sm text-grey-300 font-medium">Select Recipient’s Country</p>
                        <div class="flex flex-end items-center mt-5 md:mt-0 md:ml-10">
                            <svg
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M1.11132 4.44447C1.11132 2.6062 2.60626 1.11126 4.44452 1.11126C6.28278 1.11126 7.77773 2.6062 7.77773 4.44447C7.77773 6.28273 6.28278 7.77767 4.44452 7.77767C2.60626 7.77767 1.11132 6.28273 1.11132 4.44447ZM9.83684 9.05131L7.9508 7.16472C8.53578 6.41253 8.88854 5.46979 8.88854 4.44427C8.88854 1.99381 6.89473 0 4.44427 0C1.99381 0 0 1.99381 0 4.44427C0 6.89473 1.99381 8.88854 4.44427 8.88854C5.46979 8.88854 6.41253 8.53578 7.16472 7.9508L9.05131 9.83684C9.15964 9.94517 9.30186 9.99961 9.44408 9.99961C9.58629 9.99961 9.72851 9.94517 9.83684 9.83684C10.0541 9.61963 10.0541 9.26853 9.83684 9.05131Z"
                                    fill="#D3DCE6"
                                />
                            </svg>
                            <input type="text" placeholder="Search Country" class="text-xs ml-2" />
                        </div>
                    </div>
                    <template v-if="countries.length">
                        <ul>
                            <li
                                class="flex h-12 items-center px-6 hover:bg-snow-300 duration-500"
                                role="button"
                                v-for="(country, i) in countries"
                                :key="country.name"
                                @click="
                                    () => {
                                        showModal = false
                                        openModalClicked = false
                                        setActiveCountry(countries[i])
                                        $emit('selectCountry', i)
                                    }
                                "
                            >
                                <img
                                    :src="require('@/assets/svg/flags/' + country.code + '.svg')"
                                    alt=""
                                    class="mr-2"
                                />
                                <p class="text-grey-300 text-xs">{{ country.name }}</p>
                            </li>
                        </ul>
                    </template>
                    <template v-else-if="loading && !countries.length">
                        <div class="h-24 flex items-center justify-center w-full">
                            <img src="@/assets/svg/load.svg" alt="loader" class="w-10" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex items-center h-full w-full pb-6">
                            <p class="text-sm w-9/12 mx-auto text-center text-grey-300">Sorry, unable to fetch countries at the moment, Please try again later</p>
                        </div>
                    </template>
                </div>
            </biller-modal>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    created() {
        this.getCountries()
    },

    computed: {
        ...mapGetters('Countries', {
            countries: 'GET_COUNTRIES',
            loading: 'GET_COUNTRY_LOAD_STATE',
            active_country: 'GET_ACTIVE_COUNTRY',
        }),
    },
    methods: {
        ...mapActions('Countries', {
            getCountries: 'FETCH_COUNTRIES',
        }),

        ...mapMutations('Countries', {
            setActiveCountry: 'COMMIT_ACTIVE_COUNTRY',
        }),

        openModal() {
            this.showModal = true
            this.openModalClicked = true
        },

        closeModal() {
            if (Object.entries(this.active_country).length) {
                this.showModal = false
                this.openModalClicked = false
            }
        },
    },

    data() {
        return {
            showModal: true,
            openModalClicked: false,
        }
    },
}
</script>

<style></style>
